import { createSelector } from 'reselect';

export const selectCrewMaterialsSlice = state => state.crewMaterials;

export const selectCrewMaterials = createSelector(
  selectCrewMaterialsSlice,
  slice => slice.crewMaterials
);
export const crewMaterialsLoaded = createSelector(
  selectCrewMaterialsSlice,
  slice => slice.crewMaterialsLoaded
);
export const selectActiveCrewMaterial = createSelector(
  selectCrewMaterialsSlice,
  slice => slice.activeCrewMaterial
);

export const crewMaterialsMeta = createSelector(
  selectCrewMaterialsSlice,
  slice => slice.meta
);
export const crewMaterialsFilters = createSelector(
  selectCrewMaterialsSlice,
  slice => slice.filters
);
export const crewMaterialsEvent = createSelector(
  selectCrewMaterialsSlice,
  slice => slice.eventId
);

export const crewMaterialCreating = createSelector(
  selectCrewMaterialsSlice,
  slice => slice.isCreating
);
export const crewMaterialsUpdating = createSelector(
  selectCrewMaterialsSlice,
  slice => slice.isUpdating
);
export const crewMaterialsDeleting = createSelector(
  selectCrewMaterialsSlice,
  slice => slice.isDeleting
);
export const crewMaterialsErrors = createSelector(
  selectCrewMaterialsSlice,
  slice => slice.errors
);
